import { useContext, useEffect, useMemo } from "react";
import { TeamsFxContext } from "../Context";
import Cookies from "js-cookie";
import { Loading } from "./Loading";

export const Tab = ({ children }) => {
  const { themeString } = useContext(TeamsFxContext);

  const className = useMemo(() => {
    switch (themeString) {
      case "default":
        return "light";
      case "dark":
        return "dark";
      default:
        return "contrast";
    }
  }, [themeString]);

  useEffect(() => {
    Cookies.set("testCookie", "1", { expires: 90, sameSite: "none", secure: true });
    return () => {
      Cookies.set("testCookie", "", { expires: 90, sameSite: "none", secure: true });
    };
  }, []);

  return (
    <div className={className}>
      {Cookies.get("testCookie") ? children : <Loading error="Allow third party" />}
    </div>
  );
};
